import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import type { ITalkingPointPin } from '../../../interfaces/client';
import { isEqualPins } from '../../../utils/utils';
import { useClient } from '../../client-api';
import { deleteClientTalkingPointRelation } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUnPinTalkingPoint = (): UseMutationResult<void, AxiosError, ITalkingPointPin> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.client(client?.partnerUuid), [client?.partnerUuid]);

    return useMutation({
        mutationFn: async (payload) => {
            const pinId = client?.talkingPointPins.find((pin) => isEqualPins(pin, payload))?.id;
            await deleteClientTalkingPointRelation({ path: { relationId: pinId! } });
        },
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey });
        },
    });
};
